import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class WithStatementCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.WithStatement;
    }
    visitNode(sb, node, _options) {
        sb.context.reportUnsupported(node);
    }
}

//# sourceMappingURL=WithStatementCompiler.js.map
